// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-theme='dark'],\n*[data-theme='light'] {\n  --font-size-small: 12px;\n  --font-size-regular: 14px;\n  --font-size-medium: 16px;\n  --font-size-large: 20px;\n  --font-size-x-large: 24px;\n  --font-size-x-x-large: 48px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
